import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("revenue", "Best Sellers", { field: "stats.revenue", order: "desc" }),
    createSortOption("price", "Price, low to high", { field: "price", order: "asc" }),
    createSortOption("-price", "Price, high to low", { field: "price", order: "desc" }),
    createSortOption("newest", "Newest", { field: "datePublished", order: "desc" }),
    createSortOption("-newest", "Oldest", { field: "datePublished", order: "asc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 10,
    autocompleteKeywordsSize: 10,
    historySize: 5
}

export const SIDEBAR_ID = "sidebar-id";

export const MOBILE = window.innerWidth <= 768;

export const topCategories = [
    {
        name: "Christmas",
        url: "https://www.gruntstyle.com/collections/holiday-graphics"
    },
    {
        name: "Outerwear",
        url: "https://www.gruntstyle.com/collections/outerwear"
    },
    {
        name: "Headgear",
        url: "https://www.gruntstyle.com/collections/headwear"
    },
    {
        name: "New Arrivals",
        url: "https://www.gruntstyle.com/collections/new"
    },
    {
        name: "Best Sellers",
        url: "https://www.gruntstyle.com/collections/best-sellers"
    },
    {
        name: "Men's Collection",
        url: "https://www.gruntstyle.com/collections/men"
    },
    // {
    //     name: "Men's Graphic Tees and Tanks",
    //     url: "https://www.gruntstyle.com/collections/mens-graphic-tees-and-tanks"
    // },
    {
        name: "Women's Collection",
        url: "https://www.gruntstyle.com/collections/women"
    },
    {
        name: "Men's Hoodies & Sweatshirts",
        url: "https://www.gruntstyle.com/collections/mens-hoodies-and-sweatshirts"
    },
    // {
    //     name: "Women's Graphic Tees and Tanks",
    //     url: "https://www.gruntstyle.com/collections/womens-graphic-tees-and-tanks"
    // },
    {
        name: "Women's Hoodies & Sweatshirts",
        url: "https://www.gruntstyle.com/collections/womens-hoodies-and-sweatshirts"
    },
    {
        name: "Basic Tees & Hoodies",
        url: "https://www.gruntstyle.com/collections/basics-franchise"
    },
]

export const productTagPriority = [
    { value: "Limited Edition", text: "Limited Edition" },
    { value: "Preorder", text: "Preorder" },
    { value: "new", text: "NEW" },
    { value: "Best Seller", text: "Best Seller" },
    { value: "DNR", text: "Last Chance" },
    { value: "USA Made", text: "Made in USA" },
]